// extracted by mini-css-extract-plugin
export default {"IonModal":"GlobalHider_IonModal__IpLr-"};